<comment>
ページ中央に表示するガイド文言画像
</comment>

<template>
  <transition name="fade">
    <div v-if="show" class="guide"></div>
  </transition>
</template>

<script>
export default {
  name: 'guide',
  data: function(){
    return {
      show: false
    };
  },
  mounted: function(){
    this.show = true;
    setTimeout(()=>{
      this.show = false;
    },3000);
  }
}
</script>

<style lang="scss" scoped>
.guide{
  position: absolute;
  top: 50%;
  left: 50%;
  pointer-events: none;
  width: 256px;
  height: 171px;
  background: url(../assets/image/guide.png) no-repeat 0 0;
  background-size: contain;
  transform: translate(-50%,-50%);
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to{
  opacity: 0;
}
</style>